/**
 * Fichas de la app en las tiendas (spec 2026-10-01-descarga-la-app).
 *
 * `GOOGLE_PLAY_AVAILABLE`: con `false` la insignia de Google Play se pinta como «Muy pronto»
 * (sin enlace). Android salió a producción el 3-oct-2026 → `true`.
 */
/** Apple ID de la app (el número de la URL de la App Store). */
export const APP_STORE_APP_ID = '6808387288'
export const APP_STORE_URL = `https://apps.apple.com/es/app/match-play-juegos-de-mesa/id${APP_STORE_APP_ID}`

export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=es.matchplay.app'

export const GOOGLE_PLAY_AVAILABLE = true
